<script>

export default {
  name: 'LoginRegisterSwitcher'
}

</script>

<template lang="pug">

.row
  .col-xs-6
    router-link.text-uppercase.text-big(:to="{ name: 'register' }", :class="{ 'text-default': $route.name === 'register' }") {{ $t('Регистрация') }}
  .col-xs-6.text-right
    router-link.text-uppercase.text-big(:to="{ name: 'login' }", :class="{ 'text-default': $route.name === 'login' }") {{ $t('Войти') }}

</template>
